import script from "./Ampitor35.vue?vue&type=script&setup=true&lang=js"
export * from "./Ampitor35.vue?vue&type=script&setup=true&lang=js"

import "./Ampitor35.vue?vue&type=style&index=0&id=7fe8c294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe8c294"]])

export default __exports__